import { ImageRounded } from '@mui/icons-material';
import { Box, Card, CardContent, CardMedia, Chip,IconButton, Divider, Container,Grid, Stack, Typography, useMediaQuery, useTheme ,ontainer, Tabs, Tab,Rating,Tooltip, Skeleton, Button} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { TOKEN_KEY } from '../../config/key';
import BundleCard from '../../components/bundlecard/bundlecard';
import NoDataComponent from '../../components/nodata/nodata';
import ProgramCard from '../../components/programcard/ProgramCard';
import useDevice from '../../hooks/useDevice';
import  {useCategoriesAll} from '../../hooks/useCategoriesAll';
import { useAllPrograms } from '../../hooks/useAllPrograms';

const key = 'categoryPrograms3'
const chipsdef = [
  { id: 1, label: 'Financial Analysis & Reporting' },
  { id: 2, label: 'Business Strategy & Planning' },
  { id: 3, label: 'Investment Management' },
  { id: 4, label: 'Corporate Finance' },
  { id: 5, label: 'Risk Management' },
];

const courses = [
    { title: 'Financial Statement Analysis', image: 'https://ditrpindia.com/images/defaultcourse.jpg', price: 4000 },
    { title: 'Budgeting and Forecasting Techniques', image: 'https://ditrpindia.com/images/defaultcourse.jpg', price: 4000 },
    { title: 'Cash Flow Management', image: 'https://ditrpindia.com/images/defaultcourse.jpg', price: 4000 },
    // { title: 'Ratio Analysis for Financial Performance', image: 'https://ditrpindia.com/images/defaultcourse.jpg', price: 4000 },
    // Add more courses here
];

const CustomProgramListing2 = ({ item, ...props }) => {

    const { pageData } = props;


    const { reducer } = useSelector((state)=> state);
    const { allCategories = [], pageJson,isSiteBuilder } = reducer;
   
    const style = item && item.style;

    const userToken = Cookies.get(TOKEN_KEY)
    const headers = { 'Authorization': userToken ? userToken : '' };

    const router = useRouter();

    const { query, push, asPath } = router;

    const segments = asPath.split('/').filter(Boolean);
    
    const slug = query?.slug;

    const selectedCategory = slug;
 


useEffect(() => {
  const getCategoryData = async () => {
    
  };

  if (!isSiteBuilder) {
      getCategoryData();
  }
}, []);


    const theme = useTheme();
    const PRIMARY_MAIN = theme.palette.primary.main;
    const PRIMARY_DARK = theme.palette.primary.dark;
    const { isMobile, isTablet } = useDevice();
    const LIMIT = 12;

   
    const [selectedChip, setSelectedChip] = useState();
    const [loading, setLoading] = useState(true);
    const [activeCategory, setActiveCategory] = useState();
    const [imageUrl, setImageUrl] = useState("");
    const [tabIndex, setTabIndex] = useState(0);
    const [chips, seChips] = useState([])
    const [canScrollSubcategoryLeft, setCanScrollSubcategoryLeft] = useState(false);
    const [canScrollSubcategoryRight, setCanScrollSubcategoryRight] = useState(false);;
    const [program, setPrograme] = useState([]);
    const [count, setCount] = useState(0);
    const handleChipClick = (chipId) => {
        setSelectedChip((prevSelectedChip) => 
            prevSelectedChip === chipId ? undefined : chipId
        );
    };
    

  const [selectedId, setSelectedId] = useState(null); // State to hold the selected ID


  const handleScroll = (direction, elementId, updateScrollLeft, updateScrollRight) => {
    const element = document.getElementById(elementId);
    const scrollAmount = 200;

    if (direction === 'left') {
        element.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
        element.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    // Update the scroll states based on the current scroll position for only the relevant section
    if (updateScrollLeft && updateScrollRight) {
        updateScrollStates(element, updateScrollLeft, updateScrollRight);
    }
};

const updateScrollStates = (element, setCanScrollLeft, setCanScrollRight) => {
    if (element) {
        setCanScrollLeft(element.scrollLeft > 0);
        setCanScrollRight(element.scrollLeft < element.scrollWidth - element.clientWidth);
    }
};

// Initialize scroll states on component mount
useEffect(() => {
    const subcategoryElement = document.getElementById('subcategoryScroll');
    const courseElement = document.getElementById('courseScroll');

    // Initial scroll state setup for each section
    if (subcategoryElement) {
        updateScrollStates(subcategoryElement, setCanScrollSubcategoryLeft, setCanScrollSubcategoryRight);
        subcategoryElement.addEventListener('scroll', () => {
            updateScrollStates(subcategoryElement, setCanScrollSubcategoryLeft, setCanScrollSubcategoryRight);
        });
    }

  

    // Cleanup event listeners on component unmount
    return () => {
        subcategoryElement && subcategoryElement.removeEventListener('scroll', updateScrollStates);
        
    };
}, [activeCategory,selectedChip]);
  const handleTabChange = (event, newValue) => {
      // Check if the clicked tab is already selected
      if (tabIndex === newValue) {
          // Reset the selectedId if the same tab is clicked again
          setSelectedId(null);
      } else {
          // Set the selectedId to the new tab's ID (use newValue as ID)
          setSelectedId(newValue);
      }
      setTabIndex(newValue);
  };

    useEffect(() => {
      const getCategoryData = async () => {
          const result = await useCategoriesAll();
          const selectedCategory = result.categories.find(
            (category) => category.ct_slug === slug
        );
        setActiveCategory(selectedCategory)
        // Initialize an empty array for subcategories
        let subcategories = [];
        
        // If a matching category was found, filter the subcategories based on the selected category's ID
        if (selectedCategory) {
            subcategories = result.sub_categories
                .filter((subCategory) => subCategory.ct_parent_id === selectedCategory.id)
                .map((subCategory) => ({
                    id: subCategory.id,
                    label: subCategory.ct_name
                }));
        }
        seChips(subcategories)
      }
      
      if (!isSiteBuilder) {
        getCategoryData();
        
    }
    if(isSiteBuilder){
      seChips(chipsdef)
    }
}, [slug]);


useEffect(() => {
  const getCategoryPrograms = async () => {
    if(activeCategory){
        setLoading(true);
        const type = tabIndex === 0 ? "courses" : "bundles";
        const response = await useAllPrograms(
            headers, 
           
            `?${selectedChip!=undefined ? `sub_category_ids=${selectedChip}` : `category_ids=${activeCategory.id}`}&type=${type}&limit=${LIMIT}&basic_detail=true &get_bundles=true`,
            true,
        );
        setPrograme(response?.data);
        setCount(response?.total_data)
        setLoading(false)
        // setPrograme(response);
    }else if (segments[0] !== 'category') {
        
        setLoading(true);
        const type = tabIndex === 0? "courses" : "bundles";
        const response = await useAllPrograms(headers, `?type=${type}&limit=${LIMIT}&basic_detail=true & get_bundles=true`, true)
        setPrograme(response?.data)
        setCount(response?.total_data)
        setLoading(false)
    }
         
        
      
  };

  if (!isSiteBuilder) {
      getCategoryPrograms();
  }
 
}, [activeCategory,selectedChip, tabIndex, slug]);

    return (
        <Stack p={2}>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                {canScrollSubcategoryLeft && (
                    <IconButton 
                        onClick={() => handleScroll('left', 'subcategoryScroll', setCanScrollSubcategoryLeft, setCanScrollSubcategoryRight)}
                        sx={{ p: 1 }}
            >
                        <ArrowBackIosIcon />
                    </IconButton>
                )}

                <Box
                    id="subcategoryScroll"
                    sx={{
                        display: 'flex',
                        gap: 1,
                        overflowX: 'auto',       // Enable horizontal scrolling
                        whiteSpace: 'nowrap',     // Prevent wrapping
                        scrollBehavior: 'smooth', // Smooth scroll behavior
                        flex: 1,                  // Allow container to expand and take available space
                        '&::-webkit-scrollbar': { // Optional: Hide the scrollbar in WebKit browsers
                            display: 'none',
                        },
                    }}
                >
                    {chips.map((chip) => (
                        <Chip
                            key={chip.id}
                            label={chip.label}
                            clickable
                            onClick={() => handleChipClick(chip.id)}
                            color={selectedChip === chip.id ? 'primary' : 'default'}
                            sx={{
                                minWidth: 'fit-content',
                                padding: '10px 20px',
                                fontSize: '14px',
                                whiteSpace: 'nowrap',
                            }}
                        />
                    ))}
                </Box>

                {canScrollSubcategoryRight && (
                    <IconButton 
                        onClick={() => handleScroll('right', 'subcategoryScroll', setCanScrollSubcategoryLeft, setCanScrollSubcategoryRight)} 
                        sx={{ p: 1 }}
                    >
                        <ArrowForwardIosIcon />
                    </IconButton>
                )}
            </Box>


           
            <Box
            bgcolor={PRIMARY_MAIN}
            sx={{
                mt: 2,
              
                width: '100%', 
                p: 1,
                pb:0,
                display: 'flex',
                justifyContent: 'start', 
            }}
        >
            <Box
            bgcolor={PRIMARY_MAIN}
                sx={{
                    display: 'flex',
                    borderRadius: '8px',
                    maxWidth: 'fit-content', 
                }}
            >
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    TabIndicatorProps={{ style: { display: 'none' } }} // Hide default indicator
                    sx={{
                        '.MuiTabs-flexContainer': {
                            gap: '2px', 
                            

                        },
                    }}
                >
                    <Tab
                        label= {
                            <span
                                data-sb-label = 'course'
                                contentEditable={isSiteBuilder}
                            > 
                                {item?.props?.courseLabel ?? 'Course'}
                            </span>
                        }
                        sx={{
                           
                            backgroundColor: tabIndex === 0 ?  style?.backgroundColor : PRIMARY_MAIN,
                            color: tabIndex === 0 ? '#333333' : 'white',
                            borderRadius: '8px 8px -40px 0px',
                            fontWeight: tabIndex === 0 ? 'bold' : 'normal',
                            textTransform: 'none',
                            minHeight: '48px',
                            px: 6, 
                        }}
                    />
                    <Tab
                        label={
                            <span
                                data-sb-label = 'bundle'
                                contentEditable={isSiteBuilder}
                            >
                                {item?.props?.bundleLabel ?? 'Learning path'}
                            </span>
                        }
                        sx={{
                           
                            backgroundColor: tabIndex === 1 ? style?.backgroundColor : PRIMARY_MAIN,
                            color: tabIndex === 1 ? '#333333' : 'white',
                            borderRadius: '8px',
                            fontWeight: tabIndex === 1 ? 'bold' : 'normal',
                            textTransform: 'none',
                            borderRadius: '8px 8px 0px 0px',
                            minHeight: '48px',
                            px: 6, 
                        }}
                    />
                </Tabs>
            </Box>
        </Box>
               

        <Box sx={{ mt: 3 }}>
                      {!isSiteBuilder ? (
                          <>

                            {loading && ( 
                                <Grid container spacing={2} p={1}>
                                    {Array.from({ length: !slug ? 12: 4}).map((_, i) => (
                                        <Grid item xs={12} sm={6} md={3} >
                                            <Skeleton variant="rectangular" height={240} />
                                            <Skeleton width="60%" sx={{ mt: 1 }} />
                                            <Skeleton width="40%" sx={{ mt: 1 }} />
                                        </Grid>
                                    ))}
                                </Grid>)}
                              {tabIndex === 0 && !loading &&(
                                  <Grid container spacing={2} p={1}>
                                      {program.some((course) => course.pb_title) ? (
                                          program.map((course, index) =>
                                              course.pb_title && (
                                                  <Grid item xs={12} sm={6} md={3} key={course.id || index} sx={{ minWidth: '280px' }}>
                                                      <ProgramCard item={course} />
                                                  </Grid>
                                              )
                                          )
                                      ) : (
                                          <Grid item xs={12}>
                                             <NoDataComponent
                                              title={'No Courses Available'}
                                              display={'flex'}
                                              alignItems={'center'}
                                              maxWidth={'100vw'}
                                              width={'100%'}
                                              minWidth={'55vw'}
                                              maxHeight={300}
                                              imageHeight={200}
                                              mb={6}
                                          />
                                          </Grid>
                                      )}
                                  </Grid>
                              )}
                              
                              {tabIndex === 1 && !loading &&(
                                  <Grid container spacing={2} p={1}>
                                      {program.some((course) => !course.pb_title) ? (
                                          program.map((course, index) =>
                                              !course.pb_title && (
                                                  <Grid item xs={12} sm={6} md={3} key={course.id || index} sx={{ minWidth: '280px' }}>
                                                      <BundleCard item={course} />
                                                  </Grid>
                                              )
                                          )
                                      ) : (
                                          <Grid item xs={12}>
                                               <NoDataComponent
                                              title={'No learning path Available'}
                                              display={'flex'}
                                              alignItems={'center'}
                                              maxWidth={'100vw'}
                                              width={'100%'}
                                              minWidth={'55vw'}
                                              maxHeight={300}
                                              imageHeight={200}
                                              mb={6}
                                          />
                                          </Grid>
                                      )}
                                  </Grid>
                              )}
                            {count> 12 && 
                                <Grid xs={12} textAlign= "center" mt={3}>
                                    <Button variant="outlined"  size="large"  sx={{borderRadius:"999px", textTransform:"none"}} onClick={() => push("/all-courses")}>
                                        <span
                                            data-sb-label="showMore"
                                            contentEditable={isSiteBuilder}
                                        >
                                            {item?.props?.showMoreLabel ?? "Show more"}
                                        </span>
                                    </Button>
                                </Grid>
                            }
                          </>
                      ) : (
                          <>
                              {tabIndex === 0 && (
                                  <Grid container spacing={2}>
                                      {courses.map((course, index) => (
                                          <Grid item xs={12} sm={6} md={4} key={index}>
                                              <Card
                                                  sx={{
                                                      height: '100%',
                                                      boxShadow: 3,
                                                      borderRadius: 2,
                                                      transition: 'transform 0.2s',
                                                      '&:hover': { transform: 'scale(1.03)' },
                                                  }}
                                              >
                                                  <CardMedia
                                                      component="img"
                                                     
                                                      image={course.image}
                                                      alt={course.title}
                                                      sx={{
                                                          borderTopLeftRadius: 8,
                                                          borderTopRightRadius: 8,
                                                          height:'auto'
                                                      }}
                                                  />
                                                  <CardContent>
                                                      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                          {course.title}
                                                      </Typography>
                                                      <Typography variant="body2" color="text.secondary">
                                                          ⭐ 4.5 (100 reviews)
                                                      </Typography>
                                                      <Typography variant="h6" color="secondary" sx={{ mt: 1 }}>
                                                          ₹ {course.price}/-
                                                      </Typography>
                                                  </CardContent>
                                              </Card>
                                          </Grid>
                                      ))}
                                  </Grid>
                              )}
                              {tabIndex === 1 && (
                                  <Typography variant="h6" align="center" sx={{ mt: 3 }}>
                                      Learning path section - Coming soon
                                  </Typography>
                              )}
                              <Grid xs={12} textAlign= "center" mt={3}>
                                    <Button variant="outlined"  size="large"  sx={{borderRadius:"999px" , cursor:"text", textTransform:"none"}}>
                                        <span
                                            data-sb-label="showMore"
                                            contentEditable={isSiteBuilder}
                                        >
                                            {item?.props?.showMoreLabel ?? "Show more"}
                                        </span>
                                    </Button>
                                </Grid>
                          </>
                      )}
                  </Box>


        
    </Stack>
    )
};

export default CustomProgramListing2; 